const INITIAL_STATE = {
    registro: {},
    aguardando: false,
    modoTela: "lista",
    lista: [],
    listaCliente: [],
    listaUnidadeConsumidora: [],
    filtro: {
        id_cliente: null,
        id_unidade_consumidora: null,
    },
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "CONTRATO_MERCADO_LIVRE_MODO_TELA":
            return { ...state, modoTela: action.payload.modo, registro: action.payload.registro };

        case "CONTRATO_MERCADO_LIVRE_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "CONTRATO_MERCADO_LIVRE_FILTRO":
            return { ...state, filtro: action.payload };

        case "CONTRATO_MERCADO_LIVRE_LISTADO":
            return {
                ...state,
                lista: action.payload.data,
            };

        case "CONTRATO_MERCADO_LIVRE_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaCliente: action.payload.data,
            };

        case "CONTRATO_MERCADO_LIVRE_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };

        default:
            return state;
    }
};
